import React from "react";

import { BulkDialogRerenderGuardProvider } from "../Dialog/DialogFirestore/BulkDialogRerenderGuardProvider";
import { ErrorWrapper } from "../ErrorWrapper";

import { ViewIdResolverProvider } from "../ViewRenderer/ViewIdResolverProvider";
import { AlgorithmVersionsProvider } from "./AlgorithmVersionsProvider";
import { AppConnectMastersProvider } from "./AppConnectMastersProvider";
import { ConnectMastersProvider } from "./ConnectMastersProvider";
import { ConnectsProvider } from "./ConnectsProvider";
import { EndpointAddonMastersProvider } from "./EndpointAddonMastersProvider";
import { EndpointAddonsProvider } from "./EndpointAddonsProvider";
import { FrontendAddonProvider } from "./FrontendAddonsProvider";
import { InOrganizationContextProvider } from "./InOrganizationContextProvider";
import { MembersProvider } from "./MembersProvider";
import { OrganizationProvider } from "./OrganizationProvider";
import { PermissionsProvider } from "./PermissionsProvider";
import { RolesProvider } from "./RolesProvider";
import { SessionProvider } from "./SessionProvider";
import { VersionCategoriesProvider } from "./VersionCategoriesProvider";
import { VersionsProvider } from "./VersionsProvider";
import { ViewTypesProvider } from "./ViewTypesProvider";

/**
 * @description 組織内で使われるさまざまなデータをまとめたプロバイダ
 */
export const InOrganizationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  // NOTE: ThecsasのSnapshotLoadingWrapperを参考に、全部のAPI情報をcontextにまとめた方がいいか？
  return (
    <ErrorWrapper
      isRenderAccountSettingButton={true}
      isRenderBackToOrganizationsButton={true}
      isRenderLoginButton={true}
      isRenderLogoutButton={true}
    >
      <SessionProvider>
        <PermissionsProvider>
          <VersionsProvider>
            <OrganizationProvider>
              <MembersProvider>
                <RolesProvider>
                  <VersionCategoriesProvider>
                    <AlgorithmVersionsProvider>
                      <ViewIdResolverProvider>
                        <ViewTypesProvider>
                          <ConnectMastersProvider>
                            <ConnectsProvider>
                              <FrontendAddonProvider>
                                <AppConnectMastersProvider>
                                  <EndpointAddonsProvider>
                                    <EndpointAddonMastersProvider>
                                      <InOrganizationContextProvider>
                                        <BulkDialogRerenderGuardProvider>
                                          {children}
                                        </BulkDialogRerenderGuardProvider>
                                      </InOrganizationContextProvider>
                                    </EndpointAddonMastersProvider>
                                  </EndpointAddonsProvider>
                                </AppConnectMastersProvider>
                              </FrontendAddonProvider>
                            </ConnectsProvider>
                          </ConnectMastersProvider>
                        </ViewTypesProvider>
                      </ViewIdResolverProvider>
                    </AlgorithmVersionsProvider>
                  </VersionCategoriesProvider>
                </RolesProvider>
              </MembersProvider>
            </OrganizationProvider>
          </VersionsProvider>
        </PermissionsProvider>
      </SessionProvider>
    </ErrorWrapper>
  );
};
